module.exports = __webpack_public_path__ + "img/login-bg.ec86b109.jpg";